import { QualificationType } from './QualificationType';

export const QualificationTypes:Map<string, QualificationType> = new Map<string, QualificationType>([
  [
    'ACH_DEBIT', {
      description: 'ACH Debit',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'ACH_DEBIT',
      qualifierType: 'ACH_DEBIT',
    },
  ],
  [
    'ACH_CREDIT', {
      description: 'ACH Credit',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'ACH_CREDIT',
      qualifierType: 'ACH_CREDIT',
    },
  ],
  [
    'BILL_PAY', {
      description: 'Bill Pay',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'BILL_PAY',
      qualifierType: 'BILL_PAY',
    },
  ],
  [
    'ACH_DEBIT_OR_ACH_CREDIT', {
      description: 'ACH Debit or ACH Credit',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'ACH_DEBIT_OR_ACH_CREDIT',
      qualifierType: 'ACH_DEBIT_OR_ACH_CREDIT',
    },
  ],
  [
    'ACH_DEBIT_OR_BILL_PAY', {
      description: 'ACH Debit or Bill Pay',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'ACH_DEBIT_OR_BILL_PAY',
      qualifierType: 'ACH_DEBIT_OR_BILL_PAY',
    },
  ],
  [
    'ACH_CREDIT_OR_BILL_PAY', {
      description: 'ACH Credit or Bill Pay',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'ACH_CREDIT_OR_BILL_PAY',
      qualifierType: 'ACH_CREDIT_OR_BILL_PAY',
    },
  ],
  [
    'ACH_DEBIT_OR_ACH_CREDIT_OR_BILL_PAY', {
      description: 'ACH Debit or ACH Credit or Bill Pay',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.AchQualifier',
      transactionType: 'ACH_DEBIT_OR_ACH_CREDIT_OR_BILL_PAY',
      qualifierType: 'ACH_DEBIT_OR_ACH_CREDIT_OR_BILL_PAY',
    },
  ],
  [
    'ESTATEMENT', {
      description: 'EStatement Qualifier',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.ElectronicStatementQualifier',
      qualifierType: 'ESTATEMENT',
    },
  ],
  [
    'POS', {
      description: 'POS Transactions',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.PosQualifier',
      transactionType: 'POS',
      qualifierType: 'POS',
    },
  ],
  [
    'IB_LOGIN', {
      description: 'Online banking login',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.IbLoginQualifier',
      qualifierType: 'IB_LOGIN',
    },
  ],
  [
    'MINIMUM_BALANCE', {
      description: 'Minimum Balance',
      _class: 'com.bancvue.rcx.config.product.qualifiers.api.MinimumBalanceQualifier',
      qualifierType: 'MINIMUM_BALANCE',
    },
  ],
]);

export default QualificationTypes;
